import React from 'react';
import createStyles from '@material-ui/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { PATH } from '../../routes';

const useStyles = makeStyles(() =>
    createStyles({
        error: {
            color: '#4A4A4A',
            margin: 0,
            fontFamily: "'AreaNormal', san-serif",
            lineHeight: '20px',
            letterSpacing: '0.01071em',
            backgroundColor: '#FAFCFC',
            width: '100%',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            '& .container': {
                margin: '0 20px 25px 20px',
                '& h1, & p.heading': {
                    lineHeight: 'normal',
                },
                '& p': {
                    margin: 0,
                },
                '& h1': {
                    margin: 0,
                    fontSize: '25vw',
                    '-webkit-text-stroke': '2px #000',
                },
                '& p.heading': {
                    textAlign: 'center',
                    fontSize: '4vw',
                    marginTop: '-20px',
                    marginBottom: '10px',
                },
                '& p.text': {
                    fontSize: '16px',
                    marginBottom: '10px',
                },
                '& .link': {
                    textDecoration: 'underline',
                    marginBottom: '10px',
                    color: 'inherit',
                },
            },
        },
    }),
);

interface ErrorPageProps {
    code: number;
    headingKey: string;
    textKey: string;
    linkTextKey: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
    code,
    headingKey,
    textKey,
    linkTextKey,
}) => {
    const { error } = useStyles();
    const { t } = useTranslation();
    return (
        <div className={error}>
            <div className="container">
                <h1>{code}</h1>
                <p className="heading">{t(headingKey)}</p>
                <p className="text">{t(textKey)}</p>
                <a className="link" href={PATH.SIGNUP.HOME}>
                    {t(linkTextKey)}
                </a>
            </div>
        </div>
    );
};

export const Error404 = () => (
    <ErrorPage
        code={404}
        headingKey="error.404.heading"
        textKey="error.404.text"
        linkTextKey="error.404.link"
    />
);

export const Error500 = () => (
    <ErrorPage
        code={500}
        headingKey="error.500.heading"
        textKey="error.500.text"
        linkTextKey="error.500.link"
    />
);
